
const URL = 'https://api.chenghuida168.com/jlcy'     //测试
//const URL = 'http://manage.julicy.com'     //生产


//export const baseURL = 'http://192.168.3.206:8080/jlcy'
export const baseURL = `${URL}/`

const JuLiUrl = 'http://beta.chenghuida168.com/admin'
//const JuLiUrl = 'http://new.julicy.com'

export const wtUrl = JuLiUrl
export const loginurl  = JuLiUrl
//http://new.julicy.com/admina
